import { render, staticRenderFns } from "./MajorDetail.vue?vue&type=template&id=e2e1bafe&scoped=true&"
import script from "./MajorDetail.vue?vue&type=script&lang=js&"
export * from "./MajorDetail.vue?vue&type=script&lang=js&"
import style0 from "./MajorDetail.vue?vue&type=style&index=0&id=e2e1bafe&prod&lang=stylus&scoped=true&"
import style1 from "./MajorDetail.vue?vue&type=style&index=1&id=e2e1bafe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e1bafe",
  null
  
)

export default component.exports